import { useEffect, useState } from "react";
import { getSiteConfig } from "../services/api";

function EnvBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getSiteConfig().then((config) => {
      if (cancelled) return;
      if (config.showEnvBanner && config.bannerText) {
        setBanner({ text: config.bannerText, appEnv: config.appEnv || "development" });
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (!banner) {
      root.classList.remove("has-env-banner");
      root.removeAttribute("data-app-env");
      return undefined;
    }
    root.classList.add("has-env-banner");
    root.setAttribute("data-app-env", banner.appEnv);
    return () => {
      root.classList.remove("has-env-banner");
      root.removeAttribute("data-app-env");
    };
  }, [banner]);

  if (!banner) return null;

  return (
    <div className={`env-banner env-banner--${banner.appEnv}`} role="status">
      {banner.text}
    </div>
  );
}

export default EnvBanner;
